<template>

  <v-container fluid class="px-0 receiver-order-info-attachment-docs">

    <!-- Order Attachment Docs -->
    <order-attachment-documents class="page-content" :order="order" />

  </v-container>

</template>

<script>
import OrderAttachmentDocuments from '@/components/orders/OrderAttachmentDocuments'

export default {
  name: 'ReceiverOrderInfoAttachmentDocs',

  components: {
    OrderAttachmentDocuments
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  computed: {
    order () {
      return this.$parent.order
    }
  }
}
</script>

<style>
</style>
